module.exports = __webpack_public_path__ + "static/media/icoedit.cbb8b3b3.svg";